import React,{useState} from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import {Tools} from './Tools';
import {ResultSet} from './Inc';
import Ajax from './Ajax';
import StoryDetail from './StoryDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./Result.scss";

interface Props {
    uid:string,
    move(str:string,param?:any):void,
    result:ResultSet,
}

const Result = (props:Props)=> {
    Ajax.setUid(props.uid);

    //console.log("result",props.result);

    //const defLines:string[] = [];
    const [states,setStates] = useState({
        isLoading:false,
        isOpen:false,
        isSuki:props.result.is_suki,
        isAdd:false,
    });
    const open = ()=>{
        setStates({...states,isOpen:true});
    }
    const close = ()=>{
        setStates({...states,isOpen:false});
    }
    const goTop = ()=>{
        props.move("top");
    }
    const goSame = ()=>{
        setStates({...states,isLoading:true});
        Ajax.send("play/add",{id:props.result.story.id},(res:any)=>{
            if( res.ok ){
                props.move("board",{story:props.result.story,play:res.play});
            }
        })
    }
    const suki = ()=>{
        Ajax.send("suki/add",{id:props.result.story.id},(res:any)=>{
            if( res.ok ){
                setStates({...states,isSuki:true,isAdd:true});
            }
        })
    }

    let grade = "F";
    let grade_name = "funatoku";
    let gradeclass = "grade";

    if( props.result.play.rank===1 ){
        grade = "S+";
        grade_name = "shinigami";    
        gradeclass += " grade1";
    } else if( props.result.play.rank===2 ){
        grade = "S";
        grade_name = "shibahama";
        gradeclass += " grade2";
    } else if( props.result.play.rank>2 && props.result.play.rank<6 ){
        grade = "S-";
        grade_name = "shikaseidan";
        gradeclass += " grade3";
    } else if( props.result.play.rank>5 && props.result.play.rank<11 ){
        grade = "A+";
        grade_name = "akegarasu";
        gradeclass += " grade3";
    } else if( props.result.play.rank>10 && props.result.play.rank<21 ){
        grade = "A";
        grade_name = "anadoro";
        gradeclass += " grade4";
    } else if( props.result.play.rank>20 && props.result.play.rank<31 ){
        grade = "A-";
        grade_name = "aona";
        gradeclass += " grade5";
    } else if( props.result.play.rank>30 && props.result.play.rank<41 ){
        grade = "B+";
        grade_name = "bunshichi";
        gradeclass += " grade6";
    } else if( props.result.play.rank>40 && props.result.play.rank<51 ){
        grade = "B";
        grade_name = "botandoro";
        gradeclass += " grade7";
    }

    let text = "";
    if( props.result.play.rank>0 ){
        text = "「"+props.result.story.title + "」でランク"+props.result.play.rank+"位を獲得！ #よるのおてがみ #レトロインク";
    } else {
        text = "「"+props.result.story.title + "」で惜しくもランク圏外に散った… #よるのおてがみ #レトロインク";
    }
    const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fletters%2F"+props.result.play.gid+"&text="+encodeURIComponent(text);
    //const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fletters%2F&text="+encodeURIComponent(text);

    return (
        <div id="result">
            <div className="scr">
                <div className="level">
                    <div className={gradeclass}>{grade}</div>
                    <div className="code">{grade_name}</div>
                </div>               
                {props.result.play.rank===0 ? (
                    <div className="rank">ランク圏外</div>
                ):(
                    <div className="rank">ランク<span className="score">{props.result.play.rank}</span>位</div>
                )}
                <div className="score">
                    {Tools.score(props.result.play.score)}秒
                </div>
            </div>
            <div className="detail">
                <StoryDetail story={props.result.story} status={false} suki={suki} isSuki={states.isSuki} isAdd={states.isAdd}/>
                <div className="title">{props.result.story.title}</div>
            </div>
            <div className="tweet">
                {!states.isSuki &&
                <Button size="small" variant="outlined" color="primary" style={{marginRight:"0.5em"}} onClick={suki}><FontAwesomeIcon icon="heart"/> スキ</Button>
                }
                <a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}><Button size="small" variant="outlined" color="primary"><FontAwesomeIcon icon={['fab','twitter']} style={{marginRight:"0.5em"}}/> ツイート</Button></a>
            </div>
            <div className="notice">
                ※閲覧数以下のデータは現時点のものです。ランク獲得時の内容とは異なる場合があります。
            </div>
            <div className="bottom">
                {props.result.story.status ? (
                <Button size="small" variant="text" color="primary" onClick={open} style={{width:"100%",padding:"1em 0"}}>読む</Button>
                ):(
                <Button size="small" variant="text" color="primary" onClick={goTop} style={{width:"100%",padding:"1em 0"}}>NEW GAME</Button>
                )}
            </div>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={states.isOpen}
                onClose={close}
            >
            <div style={Tools.getModalStyle()} className="panel">
                <div className="dialogRoot">
                    <div style={{marginBottom:"1em"}}>
                        つぎのお手紙はどうしよう？
                    </div>
                    <div style={{marginBottom:"0.25em"}}>
                        <Button variant="contained" color="secondary" style={{width:"100%"}} onClick={goSame}>このおてがみを読む</Button>
                    </div>
                    <div>
                        <Button variant="outlined" color="primary" style={{width:"100%"}} onClick={goTop}>ほかのにする</Button>
                    </div>
                    <IconButton aria-label="close" onClick={close} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                        <CancelIcon/>
                    </IconButton>
                </div>
            </div>
            </Modal>

        </div>
	);
}

export default Result;